import { useHistory, useLocation } from 'react-router-dom'

const DonationsLegacyRoute = () => {
  const history = useHistory()
  const location = useLocation()
  if (location.pathname === '/fundraising/payouts') {
    history.push('/fundraising/donations/payouts')
  } else {
    history.push('/fundraising/donations/transactions')
  }
  return <></>
}
export default DonationsLegacyRoute
